<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader
  },
  data() {

    return {
      title: "Mensagens",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Mensagens",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mensagens-list_0')
    this.atualizaDataList()
  },

  methods: {

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      //this.title = `(${this.totalPages}) Mensagens: ${dtIniFormated} - ${dtFimFormated}`



      this.title = `(${e.component.totalCount()}) Mensagens: ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_mensagens')
      console.log(this.exibEmit)

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }


      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }




      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/menslist`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)


            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    gerarSeparacao(){
      console.log('gerarSeparacao')

      const idsAtualizar = this.dataGrid.getSelectedRowKeys()

      console.log('idsAtualizar')
      console.log(idsAtualizar)
      console.log(idsAtualizar.length)



      if (idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum movimento foi selecionado, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        this.dataGrid.clearSelection()

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Gerar Ordem de Separação (Movimentos " + idsAtualizar + ")",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            console.log('vai Atualizar')

            api.get(`${getBaseUrl()}api/movsgeraos`,{
              params: {
                'ids': idsAtualizar
              }
            }).then(response => {
              console.log('response.data')
              console.log(response)



              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento(s) processado(s) com sucesso!",
                text: response.data,
                showConfirmButton: false,
                timer: 3500
              }).then(() => {

                //this.refeFormTable()
                //location.reload()

                //



              })



              this.updating = false
            })
          }
        })
      }
    },

    abrirMovStatus(){
      console.log('abrirMovStatus')
      this.$router.push(`/movimentos/liststatus`)

    },


    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },



    novoMov(){
      console.log('novoMov')
      this.$router.push(`/movimento/importar/0`)
    },


    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }


      }
    },

    // atualizaDataList(){
    //   console.log('atualizaDataList')
    //   this.updating = true
    //
    //   console.log(this.dtIniFiltro)
    //   console.log(this.dtFimFiltro)
    //
    //   api.get(`${getBaseUrl()}api/movsnova`,{
    //     params: {
    //       'di': this.dtIniFiltro,
    //       'df': this.dtFimFiltro,
    //       'ee': this.exibEmit,
    //       'ed': this.exibDest,
    //       'ea': this.exibAmbos
    //     }
    //   }).then(response => {
    //     console.log('response.data')
    //     console.log(response)
    //
    //     this.dataList = new ArrayStore({
    //       key: 'mov_id',
    //       data: response.data[0],
    //     })
    //     this.totalList = response.data[1]
    //
    //     this.updating = false
    //     const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
    //     const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
    //
    //     this.title = `(${this.totalList}) Mensagens: ${dtIniFormated} - ${dtFimFormated}`
    //   })
    // },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {

        case 'EL':
          return 'Elaboração(EL)'

        case 'PR':              // desativado
          return 'Ordem Saída'  // desativado

        case 'OS':
          return 'Ordem Saída'

        case 'CF':
          return 'Pedido Conferido (CF)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'
        case 'CCT':
          return 'Com CTe (CCT)'
        case 'TRA':
          return 'Transferido (TRA)'
        case 'CAN':
          return 'Cancelado (CAN)'


        case 'SCT':
          return 'Sem CTe'
        case 'NEP':
          return 'Dentro do Prazo (Não Entregue)'
        case 'NEF':
          return 'Fora do Prazo (Não Entregue)'


      }

      return e.value
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>



        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Nova Mensagem"
              :disabled="true"
              :on-click="novoMov"/>
        </DxItem>


      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMensList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />




        <DxColumn
            sort-order="desc"
            data-field="id"
            caption="ID"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origem_id"
            caption="Origem ID"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="origem2"
            caption="Origem ID2"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="de"
            caption="Origem"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="para"
            caption="Destino"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="texto"
            caption="Mensagem"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="dtinsercao"
            caption="Inserção"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="dtenvio"
            caption="Enviado"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="dtreceb"
            caption="Recebimento"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>









        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>
